// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import { UserManagementFragmentDoc } from '../../../../shared/graphql/user/CurrentUserQuery.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LogoutUserMutationVariables = Types.Exact<{
  site?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LogoutUserMutation = { __typename?: 'Mutation', userManagementLogout?: { __typename?: 'UserManagementLogoutMutationPayload', userManagement?: { __typename?: 'UserManagement', id: string, user?: { __typename: 'UserManagementUser', id: string, email?: string, username?: string, signupTime?: number, authMethods?: Array<string> }, profile?: { __typename: 'UserManagementProfile', _id?: string, id: string, firstName?: string, lastName?: string, maidenName?: string, email?: string, country?: string, phone?: string, affiliateID?: string, city?: string, zip?: string, house?: string, lineId?: string, telegramId?: string, address?: string, state?: string, dateOfBirth?: number, language?: string, conversionCurrency?: string, hasOtp?: boolean, hasSMS2FA?: boolean, emailVerified?: boolean, passwordChangeDate?: number, contactsRequestedTime?: number, allowUsernameChange?: boolean, settings?: { __typename?: 'UserManagementSettings', siteTheme?: string, wallets?: string, loyaltyLandingDisabled?: string, loyaltyLevelNotfDisabled?: string, gameNamesInEnglish?: string, verifyEmailClosed?: string, rtpLiveOnboardingClosed?: string, preferredInGameCurrency?: string, inGameCurrencyOnboardingClosed?: string } }, countryInfo?: { __typename: 'UserManagementCountryInfo', id: string, countryCode?: string, blocked?: boolean } }, errors?: Array<{ __typename?: 'UserManagementError', code?: number, message?: string, params?: Array<{ __typename?: 'UserManagementErrorParam', name?: string, value?: string }> }> } };


export const LogoutUserMutationDocument = /*#__PURE__*/ gql`
    mutation LogoutUserMutation($site: String) {
  userManagementLogout(input: {}) {
    userManagement {
      ...UserManagementFragment
    }
    errors {
      code
      message
      params {
        name
        value
      }
    }
  }
}
    ${UserManagementFragmentDoc}`;
export type LogoutUserMutationMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserMutationDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;